/**
 * Utilitário para geração de QR Code em base64
 * Compatível com react-pdf/renderer
 */

/**
 * Gera um QR Code em formato base64 a partir de um texto
 * 
 * @param text - Texto a ser codificado no QR Code (ex: UUID)
 * @param size - Tamanho do QR Code em pixels (padrão: 150)
 * @returns Promise com string base64 do QR Code
 */
export const generateQRCodeBase64 = async (
  text: string,
  size: number = 150
): Promise<string> => {
  try {
    // Usa a biblioteca qrcode.react indiretamente através de canvas
    // Para react-pdf, precisamos gerar o QR Code como imagem base64
    
    // Cria um canvas temporário
    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      throw new Error("Não foi possível criar contexto do canvas");
    }

    // Importa dinamicamente a biblioteca QRCode
    const QRCode = (await import("qrcode")).default;

    // Gera o QR Code no canvas
    await QRCode.toCanvas(canvas, text, {
      width: size,
      margin: 1,
      color: {
        dark: "#000000",
        light: "#FFFFFF",
      },
      errorCorrectionLevel: "M",
    });

    // Converte canvas para base64
    const base64 = canvas.toDataURL("image/png").split(",")[1];

    return base64;
  } catch (error) {
    console.error("Erro ao gerar QR Code:", error);
    throw new Error("Falha ao gerar QR Code");
  }
};

